/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_Save_ResultInputs */



/**
* | output |
* | --- |
* | "Save result" |
*
* @param {League_Final_Save_ResultInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_save_result = /** @type {((inputs?: League_Final_Save_ResultInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_Save_ResultInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le résultat")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar resultado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salvar resultado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva risultato")
	return /** @type {LocalizedString} */ ("Save result")
});